import _ from "lodash";
import { UserObj } from "../services/localStarage";
// const userObj = JSON.parse(localStorage.getItem("user"));

export const urlConstants = {
  // Local
  // BASE_URI_DEV: 'http://103.234.187.79:3000/api'
  // Azure Staging
  // BASE_URI_DEV: "http://103.234.187.79:3000/api",
  BASE_URI_DEV: "https://api-vendor.avaada.com/api",
};
 
// export const SOCKET_SERVER_URL = 'ws://103.234.187.79:3000';
export const SOCKET_SERVER_URL = 'wss://api-vendor.avaada.com';

export const inrFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(value);

export const isEmptyDash = (params) => {
  if (
    params == undefined ||
    params == null ||
    params == "" ||
    params == "null"
  ) {
    return true;
  } else {
    return false;
  }
};

export const strToDate = (params) => {
  if (isEmptyDash(params)) {
    return "-";
  } else {
    let newDate = new Date(params);
    let newDay = newDate.getDate();
    let newMonth = newDate.getMonth();
    let newYear = newDate.getFullYear();
  
    return `${convertDoubleDigit(newDay)}-${convertDoubleDigit(
      newMonth + 1
    )}-${newYear}`;    
  }
};

export const returnZero = (param) => {
  if (isEmptyDash(param)) {
    return 0;
  } else {
    return param;
  }
};

export const strToDateYYMMDD = (params) => {
  let newDate = new Date(params);
  let newDay = newDate.getDate();
  let newMonth = newDate.getMonth();
  let newYear = newDate.getFullYear();

  return `${newYear}-${convertDoubleDigit(
    newMonth + 1
  )}-${convertDoubleDigit(newDay)}`;
};

export const convertToYYMMDD = (params) => {
  if (isEmptyDash(params)) {
    return "";
  } else {
    let str = params.split('-').reverse().join('-'); 
    console.log(params, str);
     
    return str;   
  }
};

// export const getSecPermission = (params) => {
//   const modulePermissions = UserObj ? UserObj?.role?.modulePermissions : [];
//   let obj = {};
//   for (let i = 0; i < modulePermissions.length; i++) { 
//     for (let j = 0; j < modulePermissions[i]?.subModules.length; j++) {
//       for (let k = 0; k < modulePermissions[i]?.subModules[j]?.features.length; k++) {
//         if (modulePermissions[i]?.subModules[j]?.features[k]?.uniqueName == params) {
//           obj = modulePermissions[i]?.subModules[j]?.features[k]?.permissions;
//         }
//       }
//     } 
//   }
//   return obj;
// };

export const getSecPermission = (featureName, moduleName) => {
  const modulePermissions = UserObj ? UserObj?.role?.modulePermissions : [];
  let obj = {}; 
  for (let i = 0; i < modulePermissions.length; i++) { 
    for (let j = 0; j < modulePermissions[i]?.subModules.length; j++) {
      if (moduleName) { 
        if (modulePermissions[i]?.subModules[j]?.uniqueName === moduleName) { 
          for (let k = 0; k < modulePermissions[i]?.subModules[j]?.features.length; k++) {
            if (modulePermissions[i]?.subModules[j]?.features[k]?.uniqueName === featureName) {
              obj = modulePermissions[i]?.subModules[j]?.features[k]?.permissions;
              break;
            }
          }
        }
      } else { 
        for (let k = 0; k < modulePermissions[i]?.subModules[j]?.features.length; k++) {
          if (modulePermissions[i]?.subModules[j]?.features[k]?.uniqueName === featureName) {
            obj = modulePermissions[i]?.subModules[j]?.features[k]?.permissions;
            break;
          }
        }
      }
    }
  } 
  return obj;
};

export const trimString = (str, digit) => {
  if (str?.length > digit) {
    return `${str.substring(0, digit)}..`;
  }
  return str;
};

export const convertDoubleDigit = (digit) => {
  let strDigit = `${digit}`;
  if (strDigit.length < 2) {
    return `0${strDigit}`;
  } else {
    return strDigit;
  }
};

export const NumberToampm = (date) => {
  if (date == "" || date == null || date == undefined) {
    return "";
  } else {
    let changeDate = new Date(date);
    return changeDate.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }
};

export const getFileNameByPath = (param) => {
  // console.log(param);
  let arr = param?.split("/");
  let str = arr[arr?.length - 1];
  let str1 = str?.slice(25, str?.length)?.split(".");
  let newStr = `${str1[0]}.${str1[2]}`;
  // console.log(newStr);

  return newStr;
};

// export const inrDateFormatNoTime = (date) => new Date(date).toLocaleString('en-IN', {year: "numeric", month: "2-digit", day: "numeric"});
export const inrDateFormatNoTime = (date) =>
  new Date(date).toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
export const inrDateFormatWithoutTime = (date) =>
  new Date(date).toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
export const inrDateFormatWithTime = (date) =>
  new Date(date).toLocaleString("en-IN");

export const separateByComma = (param) => param.toLocaleString();

export const totalInr=(input) => {
  const number = parseFloat(input, 10); 
  // console.log("inr",input, number)
  if (isNaN(number)) {
    return'Invalid input'; 
  }
  const result = new Intl.NumberFormat('en-IN').format(number);
  // console.log("inr" ,result)
  return result;
}

export const toFixedNum=(param, fixedDigit) => {
  if (_.isNumber(param) && isDecimal(param)) {
    return param?.toFixed(fixedDigit); 
  }
  return param;
}

export const returnValidVal = (param, returnVal) => {
  if (isEmptyDash(param)) {
    return returnVal;
  } else {
    return param;
  }
};

export const returnRateVal = (param) => {
  if (isEmptyDash(param)) {
    return `₹ ${toFixedNum(0, 2)}`;
  } 
  else {
    let num = Number(param);
    let returnVal = "";

    if (num == NaN) {
      returnVal =  `₹ ${toFixedNum(0, 2)}`;
    } 
    else {   
      console.log(parseInt(num));
         
      returnVal = (num < 0) ? `- ₹${totalInr(toFixedNum((Number(num) * -1), 2))}` : `₹ ${totalInr(toFixedNum(num, 2))}`;
    }

    return returnVal;
  }
};
export const isDecimal = (number) => {
  return number % 1 !== 0;
}
